interface ServicesListResponse {
  payload: {
    count: number;
    result: {
      orderUuid: string;
      description: string;
      foodCategory: string;
      foodName: string;
      orderQuantity: number | null;
      price: number | null;
      orderCreatedAt: string;
    }[];
  };
  message: string;
}

async function getServicesList(companyUuid: string, page: number, limit: number, sort: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}hospitality/get-food-order?companyUuid=${companyUuid}&page=${page}&limit=${limit}&sort=${sort}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Error fetching services list: ${response.statusText}`);
  }

  const servicesList: ServicesListResponse = await response.json();
  return servicesList;
}

export { getServicesList };
